<template>
  <div class="kontakt">
    <div class="tekst">
      <h3>Adresa</h3>
      <p>partizanski put bb - Tološi<br />81000 Podgorica, Crna Gora</p>
      <h3>Telefon</h3>
      <p>+382 (0) 67 626 673</p>
      <h3>Email</h3>
      <p><a href="mailto:info@vndnamjestaj.me">info@vndnamjestaj.me</a></p>
      <h3>Radno vrijeme: od 08h do 16h</h3>
    </div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1471.880023091362!2d19.215365704229736!3d42.45412132891254!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134deacbae0d5341%3A0xc6e1b2f811e81c64!2sPartizanski%20Put%2C%20Podgorica%2C%20Montenegro!5e0!3m2!1sen!2s!4v1648273386169!5m2!1sen!2s"
      class="maps"
      frameborder="0"
      style="border: 0"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'Kontakt',
  components: {},
  metaInfo () {
    return {
      title: 'Kontakt - VND online diskont namještaja',
      meta: [
        {
          name: 'description',
          content:
            'Poručite namještaj online ili telefonom na 067 626 673. Email: info@vndnamjestaj.me. Podgorica, Crna Gora.'
        },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        {
          property: 'og:title',
          content: 'Kontakt - VND online diskont namještaja'
        },
        { property: 'og:image', content: this.sImage },
        {
          property: 'og:url',
          content: 'https://vndnamjestaj.me' + this.$route.path
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.kontakt {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding: 80px 10px 40px;
  z-index: 100;
  background-color: #f8f9fa;
  overflow: hidden;
}

.maps {
  border: 0px;
  width: 100%;
  height: 53vh;
  bottom: -91px;
  left: 0px;
  position: absolute;
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 5%,
    rgba(0, 0, 0, 1) 28%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 5%,
    rgba(0, 0, 0, 1) 28%
  );
}
.tekst {
  width: 48vw;
  position: relative;
  margin: 5vh auto 0px;
  text-align: center;
  line-height: 1.5;
  p {
    margin: 0px;
    margin-bottom: 30px;
  }
  h3 {
    text-transform: uppercase;
    font-size: 1vw;
    margin: 0vw;
    padding: 0px;
  }
}

@media only screen and (max-width: 600px) {
  .kontakt {
    position: relative;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    top: 0px;
    left: 0px;
    padding: 0x 10px 0px;
    z-index: 100;
    background-color: #f8f9fa;
    overflow: hidden;
  }
  .maps {
    border: 0px;
    width: 100%;
    height: 50vh;
    bottom: 0px;
    left: 0px;
    position: absolute;
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 5%,
      rgba(0, 0, 0, 1) 28%
    );
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 5%,
      rgba(0, 0, 0, 1) 28%
    );
  }
  .tekst {
    width: 85vw;
    position: relative;
    margin: 1vh auto 0px;
    text-align: center;
    line-height: 1.5;
    p {
      margin: 0px;
      margin-bottom: 30px;
    }
    h3 {
      text-transform: uppercase;
      font-size: 4vw;
      margin: 0vw;
      padding: 0px;
    }
  }
}
</style>
